import { render } from "./Badges-Component.vue?vue&type=template&id=32994c8b&scoped=true"
import script from "./Badges-Component.vue?vue&type=script&lang=js"
export * from "./Badges-Component.vue?vue&type=script&lang=js"

import "./Badges-Component.vue?vue&type=style&index=0&id=32994c8b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32994c8b"]])

export default __exports__